import React, { Component } from "react";
import { SlPageTitle, SlSectionTitle , SlBranchDisplay, SlButton} from "./editors"
import { Card, CardText, CardBody, CardTitle } from 'reactstrap';
import { metadataService, userService } from "../_services";
import { history } from "../_helpers"

export class SuspendedFlag extends Component {
    
handleContactCustomerService(){
    history.push('customer-service')
}
  
render() {
    return (
      <div>
        <SlPageTitle pageName="SuspendedFlag" />
        <Card>
          <CardBody>
            
              <div className="text-center">
              <p>{
                    metadataService.getMessage('SuspendedFlagMessage', metadataService.getLabel('SupportPhone'))
                }</p>
              
              <SlButton name='ContactCustomerService' onClick={this.handleContactCustomerService}/>
              </div>
            
          </CardBody>
        </Card>
      </div>
    )
  }}